module.exports = __webpack_public_path__ + "img/guardian001.4f69ab2e.jpg";